// 封装el-button，加上防抖和loading
<template>
  <el-button v-bind="$attrs" :loading="loadingStatus" @click="handleClick">
     <slot></slot>
  </el-button>
</template>

<script setup>
import { getCurrentInstance, ref } from 'vue';

const { emit } = getCurrentInstance()

const props = defineProps({
  autoLoading: {
    type: Boolean,
    default: true
  },
})

const loadingStatus = ref(false)

const handleClick = () => {
  if (props.autoLoading) {
    loadingStatus.value = true
  }
  emit('handleClick', () => {
    loadingStatus.value = false
  })
}
</script>